import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { updateOrderTaxableState } from "../../redux/order";
import { updateItemsMisMatch, makeAllItemsMatch } from "../../redux/cart";
import { checkSkusMatchingCar } from "../../services/sku";
import Header from "../../components/Categories/Header/Header";
import OrderSummary from "../../components/Cart/OrderSummary/OrderSummary";
import MechanicAutoComplete from "../../components/MechanicAutoComplete/MechanicAutoComplete";
import CartItems from "../../components/Cart/CartItems/CartItems";
import CarDropdowns from "../../components/CarDropdowns/CarDropdowns";
import PromoBanner from "../../components/PromoBanner/PromoBanner";
import emptyCart from "../../assets/images/emptyCart.png";

const Cart = () => {
  const cart = useSelector((state) => state.cart);
  const { selectedCar } = useSelector((state) => state.car);
  const selectedMechanic = useSelector((state) => state.mechanic);
  const dispatch = useDispatch();
  const currentCarId = selectedCar.carDetails?.id;
  const cartSkusList = [
    ...cart.skus,
    ...cart.bundles.flatMap((bundle) => bundle.skuList.map((sku) => sku)),
  ];

  useEffect(() => {
    if (selectedMechanic) {
      const { isTaxable } = selectedMechanic;
      dispatch(updateOrderTaxableState(isTaxable));
    } else {
      dispatch(updateOrderTaxableState(false));
    }
  }, [dispatch, selectedMechanic]);

  useEffect(() => {
    const validateItems = async (cartItemsIds, currentCarId) => {
      try {
        await checkSkusMatchingCar(cartItemsIds, currentCarId);
        dispatch(makeAllItemsMatch());
      } catch (error) {
        if (error.response.status === 400) {
          dispatch(updateItemsMisMatch(error.response.data.skuIdList));
        } else {
          console.log(error);
        }
      }
    };
    const cartItemsIds = cartSkusList.reduce((accumulator, currentCartItem) => {
      if (currentCartItem.id) {
        return [...accumulator, currentCartItem.id];
      } else {
        return [...accumulator];
      }
    }, []);

    if (currentCarId && cartItemsIds.length !== 0) {
      validateItems(cartItemsIds, currentCarId);
    }
    // eslint-disable-next-line
  }, [currentCarId]);

  let content;
  if (cart.skus.length === 0 && cart.bundles.length === 0) {
    <Link to="/categpries"></Link>;
    content = (
      <div className="flex flex-col gap-4 items-center">
        <img src={emptyCart} alt="emty cart" className="w-96" />
        <h3 className="text-center">
          عرية التسوق فارغة تسوق{" "}
          <Link to="/categories" className="text-blue-600 underline">
            الأقسام الرئيسية
          </Link>{" "}
          الأن
        </h3>
      </div>
    );
  } else {
    content = (
      <>
        <CarDropdowns />
        <MechanicAutoComplete />
        <PromoBanner />
        <h2 className="mb-6">
          العربة ( {cart.skus.length} منتجات) و ( {cart.bundles.length} مجموعات)
        </h2>
        <section className="flex gap-6 flex-col lg:flex-row">
          <CartItems />
          <OrderSummary />
        </section>
      </>
    );
  }
  return (
    <div className="flex flex-col min-h-screen">
      <Header hideSearch addNewItem />
      <main dir="rtl" className={["mb-72", "mx-8", "sm:mx-16"].join(" ")}>
        {content}
      </main>
    </div>
  );
};

export default Cart;
